import React from "react"
import {getMonthName} from "../../insight/months"
import styles from "./transaction-date.module.scss"

export interface TransactionDateProps {
  dateValue: string
  mobile?: boolean
}

export const TransactionDateYearBelow : React.FC<TransactionDateProps> = ({dateValue}) => {
  const date = new Date(dateValue)
  const currentYear = date.getFullYear() === new Date().getFullYear()
  return <>
    <span>{date.getDate()} {getMonthName(date)}</span>
    {currentYear ? null : <div>{date.getFullYear()}</div>}
  </>
}

export const TransactionDate : React.FC<TransactionDateProps> = ({dateValue, mobile}) => {
  const date = new Date(dateValue)
  const currentYear = date.getFullYear() === new Date().getFullYear()
  return <>
    <span className={mobile ? styles.MobileDate : ""}>{date.getDate()} {getMonthName(date)} {currentYear ? null : date.getFullYear()}</span>
  </>
}